import SiteHeader from "../modules/site-header";

export default () => {
    const nodeSelectors = {
        container: '[js-site-nav-mobile="container"]',
        opener: '[js-site-nav-mobile="opener"]',
    }

    function init() {
        if (!document.querySelector(nodeSelectors.container)) {
            return
        }

        // Close mobile nav on Esc key press
        jQuery(document).keyup(function(e) {
            if (e.key === "Escape") {
                close();
            }
        });

        // Open/Close mobile nav
        jQuery(nodeSelectors.opener).on('click', function () {
            if( jQuery(nodeSelectors.container).is(':visible') ) {
                close()
            } else {
                open()
            }
        })

        // Toggle submenu
        jQuery(nodeSelectors.container + ' .menu-item-has-children').on('click', function (e) {
            e.stopPropagation()

            jQuery(this).toggleClass('menu-item-has-children--submenu-is-active')

            let subMenu = jQuery(this).find(' > .sub-menu')

            if( !subMenu.is(':visible') ) {
                e.preventDefault()
            }

            subMenu.slideToggle()
        })

        // Toggle mega menu
        jQuery(nodeSelectors.container + ' .mega-menu-opener').on('click', function (e) {
            e.stopPropagation()

            let clickedElement = jQuery(e.target);

            if ( jQuery(e.target).hasClass('tab-opener') ) {
                return
            }

            jQuery(this).toggleClass('mega-menu-is-active')

            let subMenu = jQuery(this).find(' > .l-mega-menu')

            if( !subMenu.is(':visible') ) {
                e.preventDefault()
            } else {

            }

            subMenu.slideToggle()
        })
    }

    // Mobile nav functions
    function open() {
        jQuery('body, html').addClass('u-mobile-nav-active-no-scroll')
        jQuery(nodeSelectors.opener).addClass('hamburger--active');
        jQuery(nodeSelectors.container).fadeIn(250);
        jQuery(SiteHeader().nodeSelectors.container).addClass('site-header--mobile-nav-is-active')
    }

    function close() {
        jQuery('body, html').removeClass('u-mobile-nav-active-no-scroll')
        jQuery(nodeSelectors.container).fadeOut(200);
        jQuery(nodeSelectors.opener).removeClass('hamburger--active');
        jQuery(SiteHeader().nodeSelectors.container).removeClass('site-header--mobile-nav-is-active')
    }

    return Object.freeze({
        init,
        close,
        open,
        nodeSelectors
    })
}